import { Injectable } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ShortcutsComponent} from "../modals/shortcuts/shortcuts.component";
import {WhatsNewComponent} from "../modals/whats-new/whats-new.component";

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  active: boolean = false;
  modalMap: { [key: string]: any } = {
    'shortcuts': ShortcutsComponent,
    'whats-new': WhatsNewComponent,
  }
  constructor(private dialog: MatDialog) { }

  openDialog(modalName: string, data: any = {}) {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(this.modalMap[modalName], {data: data});
    this.active = true;
    dialogRef.afterClosed().subscribe(() => {
      this.active = true;
    })
  }

  closeDialog() {
    this.dialog.closeAll();
    this.active = false;
  }
}
